module.exports = __webpack_public_path__ + "static/hr-22ccf7800dc8cca2a4cd1063b521ef78.png";